import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Members } from 'app/trello/models/members';
import { RequestErrorThrower } from 'app/trello/services/request-error-thrower';
import { TokenService } from 'app/trello/services/token.service';
import { environment } from 'environments/environment';
import { catchError, Observable, switchMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MembersFetcher {

  constructor(
    private readonly http: HttpClient,
    private readonly requestErrorThrower: RequestErrorThrower,
    private readonly tokenService: TokenService,
  ) {
  }

  public fetch(
    now: string,
  ): Observable<Members> {

    const url = `${environment.apiRoot}${environment.endpoints.members}`;

    const queryParameters =
      this.buildQueryParameters(now);

    return this.tokenService.userToken
      .pipe(
        take(1),
        switchMap((userToken) =>

          this.http.get<Members>(
            url,
            {
              headers: {Authorization: `Bearer ${userToken}`},
              params: queryParameters,
            },
          ),
        ),
        catchError((error: any) => {

          console.error('An error occurred fetching members:', error);

          return this.requestErrorThrower.throwError(error);
        }),
      );
  }

  private buildQueryParameters(
    now: string,
  ): { now: string; } {

    return {
      now,
    };
  }

}
